// extracted by mini-css-extract-plugin
export var name = "authorPhotoNameTitle-module--name--207c5";
export var textLink = "authorPhotoNameTitle-module--textLink--bdba7";